module.exports = __webpack_public_path__ + "img/sync-hei.74ea0e20.svg";